export default {
	'add-new-keyword': '',
	keyword: '',
	'the-keyword': ''
}